import { useCallback, useEffect, useState } from 'react';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { GetPowerBIReportEmbedConfig } from '../../api/services/reports';
import {SpinnerIcon } from '../shared/Icons/index';
import './PowerBiReport.scss';

export const PowerBiDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [embedUrl, setEmbedUrl] = useState('');
  const [token, setToken] = useState('');
  const [reportId, setReportId] = useState('');
  function requireEnvVar(name: string): string {
    const value = process.env[name];
    if (!value) throw new Error(`Environment variable ${name} is not defined`);
    return value;
  }
  const fetchReport = useCallback(async () => {
    try {

      const selectedReportId = requireEnvVar('REACT_APP_REPORT_ID');

      setReportId(selectedReportId);
      const embedResponse = await GetPowerBIReportEmbedConfig(selectedReportId);
      setEmbedUrl(embedResponse.data.data.embedUrl);
      setToken(embedResponse.data.data.embedToken.token);
      setLoading(false);
    } catch (error) {
      console.error('Failed to load report:', error);
    }
  }, []);

  useEffect(() => {
    void fetchReport();
  }, [fetchReport]);

  const cssClassName = 'dashboard'
  const eventHandlers = new Map([
    ['loaded', function () {
        console.log('Report loaded');
    }],
    ['rendered', function () {
        console.log('Report rendered');
    }],
    /* eslint-disable */
    ['error', function (event:any) {
        console.log(event.detail);
    }]
    /* eslint-enable */
  ]);

  return (
    <div className='powerbi-report-container'>
      {
      loading ? (
        <SpinnerIcon />
      ) : (
        <PowerBIEmbed
          eventHandlers = { eventHandlers }
          cssClassName = { cssClassName }
          getEmbeddedComponent = { (embedObject) => {
            console.log(`Embedded object of type "${ embedObject.embedtype }" received`);
          } }
          embedConfig = {{
            type: 'report',   // Supported types: report, dashboard, tile, visual, qna and paginated report
            id: reportId,
            embedUrl,
            accessToken: token,    // Keep as empty string, null or undefined
            tokenType: models.TokenType.Embed
          }}
        />
      )
      }
    </div>
  );
}